import DocumentUploadForm, { DocumentUploadFormButtonsOverride } from '@Components/DocumentUploadForm'
import {
    UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES,
    UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES,
} from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadForm'
import React, { useContext, useRef } from 'react'
import { StoresContext } from '@App/contexts'
import { Maybe } from '@Types'
import { generateBulkOverclaimDocumentUploadUrl } from '@App/api/routes/overclaim'
import './index.scss'
import { observer } from 'mobx-react'
import OverclaimDocumentationWarning from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadForm/OverclaimDocumentationWarning'
import BulkDocumentUploadConfirmationPopup from '@Components/Popups/ConfirmationPopup/BulkDocumentUploadConfirmationPopup'
import { DocumentToUpload } from '@Entities/document/document-to-upload'
import OverclaimBulkActionControl from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/OverclaimBulkActionControl'

const DocumentBulkAction = () => {
    const { rightsholderStore, userStore, overclaimSearchBulkActionStore } = useContext(StoresContext)
    const [displayConfirmationPopup, setDisplayConfirmationPopup] = React.useState<boolean>(false)

    const documentUploadFormButtonsOverrideRef = useRef<DocumentUploadFormButtonsOverride>(null)

    const generateS3PresignedUrl = async (
        fileName: string,
        fileSize: number,
        fileDescription: Maybe<string>,
        fileHash?: Maybe<string>
    ) => {
        const response = await generateBulkOverclaimDocumentUploadUrl(
            rightsholderStore.currentRightsholderId,
            Array.from(overclaimSearchBulkActionStore.idsSelectedForBulkAction),
            fileName,
            fileSize,
            fileDescription,
            fileHash
        )
        return response.data
    }

    const onUpload = () => {
        setDisplayConfirmationPopup(true)
        documentUploadFormButtonsOverrideRef.current?.resetForm()
        overclaimSearchBulkActionStore.resetSelection()
    }

    return (
        <>
            <OverclaimBulkActionControl
                submitButtonOnClick={() => documentUploadFormButtonsOverrideRef.current?.showUploadDisclaimer()}
                submitButtonText="Upload Documents"
                isSubmitDisabled={
                    overclaimSearchBulkActionStore.idsSelectedForBulkAction.size === 0 ||
                    !overclaimSearchBulkActionStore.areFilesStaged ||
                    userStore.isInternal
                }
                instructions="Select all overclaims you wish to upload documents for, then click the Upload Documents button."
                bulkSelectionCountText="document upload"
                displayConfirmationPopup={displayConfirmationPopup}
                confirmationPopup={
                    <BulkDocumentUploadConfirmationPopup onClose={() => setDisplayConfirmationPopup(false)} />
                }
            />
            <div className="bulk-document-file-upload">
                <DocumentUploadForm
                    hashFiles
                    ref={documentUploadFormButtonsOverrideRef}
                    confirmationPopupConfig={{
                        confirmationPopupTitle: 'Upload Documentation',
                        confirmationPopupBody: <OverclaimDocumentationWarning />,
                    }}
                    allowedFilesConfig={{
                        allowedFileTypes: UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES,
                        maximumFileSizeInBytes: UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES,
                    }}
                    displayConfig={{ hideUploadButtons: true, hideHeader: true, hideConfirmationText: true }}
                    generateS3PresignedUrl={generateS3PresignedUrl}
                    onFileStaged={(files: DocumentToUpload[]) =>
                        overclaimSearchBulkActionStore.setAreFilesStaged(files.length !== 0)
                    }
                    onUpload={() => onUpload()}
                />
            </div>
        </>
    )
}
export default observer(DocumentBulkAction)
